module.exports = __webpack_public_path__ + "static/img/buying_one.8768983d.jpg";